import { render, staticRenderFns } from "./CommonCarouselComponent.vue?vue&type=template&id=96eebe70"
import script from "./CommonCarouselComponent.vue?vue&type=script&lang=js"
export * from "./CommonCarouselComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports